import React from "react";
import FaqsCompo from "@/component/faqs";
import FibreProsSection from "@/bit/components/next13.components.fibre-pros-section";
import ServiceCard from "@/component/service-card";
import LocationText from "@/component/location-text";

const filePath = "layout/distri.js";

/**
 * @name Layout
 * @description Connectivity page layout
 * @param {any} props
 * @returns {React.FC}
 */
export default function Layout(props) {
  const { orionAlias } = props;
  return (
    <>
      {props && props["MODULO_CARDS"] && (
        <ServiceCard alias={orionAlias} orionInfo={props["MODULO_CARDS"]} />
      )}

      {props && props["MODULO_CARDS"] && <LocationText orionInfo={props["MODULO_CARDS"]} />}

      {props &&
        props["LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION"] &&
        props["LISTADO_PASOS_ICONO_TITULO_DESCRIPCION"] && (
          <FibreProsSection
            sectionLeft={props["LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION"]}
            sectionRight={props["LISTADO_PASOS_ICONO_TITULO_DESCRIPCION"]}
            simplePhone={props["MODULO_SIMPLEPHONE"]}
          />
        )} 
      {props && props["FAQS_PREGUNTAS_FRECUENTES"] && (
        <FaqsCompo {...props["FAQS_PREGUNTAS_FRECUENTES"]} />
      )}
    </>
  );
}
